import React from 'react'
import { Button, Card, Col, Row, Table, Tooltip, Typography } from 'antd'
import { QuestionCircleOutlined, ClockCircleOutlined } from '@ant-design/icons'
import { userCan } from '@/utils/authority';
import moment from 'moment';
import Styles from './index.less';
const { Title } = Typography;
/**
 * @description - This component list down all the playbook for current resource or risk.
 * @param {string} description - Helper text for playbooks.
 * @param {string} signature - Current risk.
 * @param {Object[]} playbooksList - Playbook list for current resource or risk.
 * @callback onViewPlaybook - Handler for View Playbook button.
 * @callback onCreate - Handler for Create Playbook button.
 * @returns {JSX}
 */
function PlaybooksList({ description = '', signature, onViewPlaybook, playbooksList, onCreate }) {

    const columns = [
        {
            title: () => <span className="pl-4">Name</span>,
            dataIndex: 'name',
            key: 'name',
            width: '80%',
            render: (text, record) => {

                // Estimate execution time
                let lastExecutionTime = '';
                if (
                    record.hasOwnProperty('historyStatus') &&
                    record.historyStatus.map(e => e.hasOwnProperty('executionTime'))
                ) {
                    lastExecutionTime = record.historyStatus[record.historyStatus.length - 1].executionTime;

                    if (typeof lastExecutionTime === 'string') {
                        lastExecutionTime = moment(lastExecutionTime).format('MMM Do, YYYY hh:mm a');
                    } else if (typeof lastExecutionTime === 'object') {
                        lastExecutionTime = moment(lastExecutionTime.toDate()).format('MMM Do, YYYY hh:mm a');
                    } else {
                        lastExecutionTime = '';
                    }
                }

                return (
                  <div className={Styles.signatureNameContainer}>

                    <span className={Styles.signatureName}>
                      <Tooltip title={record.name} placement="topLeft">
                        {record.name}
                      </Tooltip>
                    </span>

                    <div className={Styles.signatureMoreInfo}>
                      <ClockCircleOutlined />
                      <span>
                        {lastExecutionTime.length > 0
                                    ? `Last executed at ${lastExecutionTime}`
                                    : 'Not executed'}
                      </span>
                    </div>

                  </div>
                );
            },
        },
        {
            title: '',
            align: 'right',
            dataIndex: 'viewPlaybook',
            render: (text, record) => (<Button className="mr-2" onClick={() => onViewPlaybook(record)} type="primary" ghost>View Playbook</Button>)
        },
    ];

    return (

      <div className="pl-3 pt-3 pr-3 pb-2">

        <Row className="pl-2 mb-2">
          <Col>
            <Title level={4}>
                        Automate Remediation
              <Tooltip title={description}>
                <QuestionCircleOutlined className="ml-2" />
              </Tooltip>
            </Title>
          </Col>
        </Row>

        <div className={Styles.actionBar}>
          <Title level={5}>Automated Remediation(s) for this {signature ? 'risk' : 'resource'}</Title>
          <Tooltip
            title={
                        userCan('create-playbook')
                            ? 'Create new playbook'
                            : "You don't have permission to create new playbook."
                    }
          >
            <Button
              disabled={!userCan('create-playbook')}
              type="primary"
              onClick={onCreate}
              onClick={userCan('create-playbook', onCreate)}
            >
                        Create Playbook
            </Button>
          </Tooltip>
        </div>

        <Table
          rowKey={record => record.id}
          className={Styles.playbookListTable}
          columns={columns}
          dataSource={playbooksList}
          size="middle"
          pagination={{ pageSize: 3 }}
          locale={{
                    emptyText: 'No Playbooks.',
                }}
        />

      </div>
    )
}

export default PlaybooksList
